import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { moneyInOutAction } from './money-in-out.actions';
import { MoneyInOutService } from '../service/money-in-out.service';

@Injectable()
export class MoneyInOutEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private moneyInOutService: MoneyInOutService
  ) {}

  moneyInOutListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(moneyInOutAction.moneyInOutListRequest),
      tap((_) => this.logger.debug('@Effect [Money In Out] money in out list request ')),
      switchMap(({ payload }) => {
        return this.moneyInOutService.list({ ...payload }).pipe(
          map((response) => {
            return moneyInOutAction.moneyInOutListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  viewMoneyInOutDetailRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(moneyInOutAction.viewMoneyInOutRequest),
      tap((_) => this.logger.debug('@Effect [Money In Out] money in out detail request ')),
      switchMap((payload) => {
        return this.moneyInOutService.detail(payload.docNo).pipe(
          map((response) => {
            return moneyInOutAction.viewMoneyInOutResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
